import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { propStr } from '../../../../../../../../helpers/custom-prop-types';
import SplitText from '../../../../../../../Ui/Common/SplitText';
const DirectAnswerRow = (props) => {
    const { answer } = props;
    const renderFunc = useCallback((row) => {
        if ([
            '①会社の強み',
            '②本プロジェクトに関係する実績',
            '③本プロジェクトの想定の進め方',
        ].includes(row)) {
            return _jsx("b", Object.assign({ className: 'title_value' }, { children: row }));
        }
        return row;
    }, []);
    return (_jsx("div", Object.assign({ className: 'answer_row' }, { children: _jsx(SplitText, { convertLink: true, renderFunc: renderFunc, text: answer }) })));
};
DirectAnswerRow.propTypes = {
    answer: propStr().isRequired,
};
export default DirectAnswerRow;
